import { useQueryClient } from '@tanstack/react-query'

import { getMeetingStatus } from 'services/lead'
import { GetMeetingStatus } from 'services/types/lead'
import { meetingKey } from 'utils/constants/queryKey'

import { AppQueryOptions, useAppQueryMap } from './use-app-query'
import { STALE_TIME } from 'utils/constants'

interface MeetingStatus {
  leadId: string
  leadAppointmentId: string
}

const mapMeetingStatus = (data: GetMeetingStatus): MeetingStatus => ({
  leadId: data.lead_id,
  leadAppointmentId: data.lead_appointment_id,
})

const useMeetingStatus = (options?: AppQueryOptions) =>
  useAppQueryMap(meetingKey.meetingStatus(), getMeetingStatus, mapMeetingStatus, {
    staleTime: STALE_TIME.minute * 5,
    ...options,
  })

export const useInvalidateMeetingStatus = () => {
  const queryCache = useQueryClient()

  const invalidate = () => {
    queryCache.invalidateQueries(meetingKey.meetingStatus())
  }

  return invalidate
}

export default useMeetingStatus
